import React from 'react';
import CompanyDemonstrativeAndDuplicate from './Company';

const DemonstrativeAndDuplicate: React.FC = () => {
  return <CompanyDemonstrativeAndDuplicate />;
};

export default DemonstrativeAndDuplicate;
